import { OreButton, OreStack, SvgArrowLeft } from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useContractNewProducts } from '@/Contract/ui/context'
import { productContractingTranslation } from '@/Contract/ui/contractTranslation'
import { Step1Form } from '@/Contract/ui/hooks'

export const ContractNewProductsStep1Actions = (): JSX.Element => {
  const { t } = useTranslation()

  const { handleSubmit } = useFormContext<Step1Form>()
  const { saveStep1, navigateToOrigin } = useContractNewProducts()



  return (
    <OreStack space="large" direction="row" placeContent="space-between">
      <OreButton
        data-testid="previous"
        category={'tertiary'}
        icon={<SvgArrowLeft />}
        onClick={navigateToOrigin}
      >
        {t(
          productContractingTranslation.contractProductPage.step1.buttons.previous.label,
        )}
      </OreButton>

      <OreButton
      data-testid="next"
      category={'primary'}
      onClick={handleSubmit(saveStep1)}
      >
        {t(productContractingTranslation.contractProductPage.step2.buttons.next.label)}
      </OreButton>
    </OreStack>
  )
}
